<template>
  <div>
    <p></p>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Район" v-model="finder">
    </div>
    <div>
      <div
        style="cursor:pointer"
        v-for="info in search"
        :key="info.id"
        
      >
        <p @click="$set(show, info.id, !show[info.id])">{{info.name}}</p>
        <table class="table table-sm" v-if="!show[info.id]">
          <tr>
            <th v-for="str in info.stages" :key="str.id">{{str.title}}</th>
          </tr>
          <tr>
            <td v-for="str in info.stages" :key="str.id" :class="str.selects[test[info.id][str.id]].class">
              <component :is="str.type" :data="str.selects" v-model="test[info.id][str.id]"/>{{test}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import modifyStages from "../../../assets/modifyStages.json";
import selectBlock from "./blocks/select";
import inputBox from "./blocks/input";

export default {
  computed: {
    search: function() {
      this.show = [];
      var buffer = {};
      buffer = Object.assign({}, this.info);
      if (this.finder == "") {
        return buffer;
      }
      for (var i in buffer) {
        if (buffer[i].name.indexOf(this.finder) == -1) delete buffer[i];
      }
      return buffer;
    }
  },
  data() {
    return {
      info: modifyStages,
      finder: "",
      show: [],
      test: {1:{1:1,2:1},2:{1:1}}
    };
  },
  components:{
    selectBlock,
    inputBox
  }
};
</script>
